// Reads card type design form inputs — same shape as legacy card_type_preview gatherFormData.
export function gatherCardTypeFormData(form) {
  const get = (key) => {
    const input = form.querySelector(`[name="card_type[${key}]"]`)
    return input ? input.value.trim() : ""
  }
  const getFile = (key) => {
    const input = form.querySelector(`[name="card_type[${key}]"]`)
    return input?.files?.[0] || null
  }
  const getLegacyFile = (key) => {
    const input = form.querySelector(`[name="card_type[${key}_file]"]`)
    return input?.files?.[0] || null
  }
  const getPreviewDataUrl = (key) => {
    const input = form.querySelector(`[name="card_type[${key}]"]`)
    const v = input?.value?.trim()
    return v && v.startsWith("data:") ? v : null
  }
  const cropperPreviewSrc = (target) => {
    const el = form.querySelector(`[data-admin--card-type-image-cropper-target="${target}"]`)
    const src = el?.src?.trim()
    if (!src || src === "#") return null
    if (src.startsWith("data:") || src.startsWith("http:") || src.startsWith("https:")) return src
    return null
  }
  const showNameCheckbox = form.querySelector(
    "input[type=checkbox][name='card_type[show_name_on_apple_card]']"
  )
  const show_name_on_apple_card = showNameCheckbox ? showNameCheckbox.checked : true

  return {
    name: get("name"),
    show_name_on_apple_card,
    background_colour: get("background_colour") || "#ffffff",
    foreground_colour: get("foreground_colour") || "#000000",
    label_colour: get("label_colour") || "#000000",
    ios_logo: "",
    ios_logo_file: getLegacyFile("ios_logo"),
    ios_strip: "",
    ios_strip_file: getLegacyFile("ios_strip"),
    logo_android: "",
    logo_android_file: getLegacyFile("logo_android"),
    logo_large: "",
    logo_large_file: getLegacyFile("logo_large"),
    card_logo_image_square_source: getFile("card_logo_image_square_source"),
    card_logo_image_wide_source: getFile("card_logo_image_wide_source"),
    card_strip_image_source: getFile("card_strip_image_source"),
    card_hero_image_source: getFile("card_hero_image_source"),
    card_logo_image_square_preview: getPreviewDataUrl("_square_preview_data"),
    card_logo_image_wide_preview: getPreviewDataUrl("_wide_preview_data"),
    card_logo_image_square_preview_from_dom: cropperPreviewSrc("squarePreview"),
    card_logo_image_wide_preview_from_dom: cropperPreviewSrc("widePreview"),
    card_strip_image_preview: getPreviewDataUrl("_strip_preview_data"),
    card_strip_image_preview_from_dom: cropperPreviewSrc("stripPreview"),
    card_hero_image_preview: getPreviewDataUrl("_hero_preview_data"),
    card_hero_image_preview_from_dom: cropperPreviewSrc("heroPreview"),
  }
}
